"use strict";

exports.__esModule = true;
var _elementEditorActions = require("./elementEditorActions");
Object.keys(_elementEditorActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _elementEditorActions[key]) return;
  exports[key] = _elementEditorActions[key];
});
var _ElementEditorController = require("./ElementEditorController");
Object.keys(_ElementEditorController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementEditorController[key]) return;
  exports[key] = _ElementEditorController[key];
});